import { batch } from "react-redux";
import { TrackJS } from "trackjs";
import uuid from "uuid/v4";
import { transformCardForProcessing, transformCardForRegistry, } from "helpers/transforms/mobile_pay";
import { getCheckInfo, getMerchantInfo, postCreditCardPayment, } from "interfaces/mobile_pay";
import { registerCard } from "interfaces/order";
import { RequestStatus } from "types/requests";
import { BASE_URL } from "api_urls";
export var SET_CHECK_INFO = "mobile_pay/SET_CHECK_INFO";
export var SET_MERCHANT_INFO = "mobile_pay/SET_MERCHANT_INFO";
export var SET_PROCESSED_PAYMENT_INFO = "mobile_pay/SET_PROCESSED_PAYMENT_INFO";
export var SET_CREDIT_CARD_REQUEST_STATUS = "mobile_pay/SET_CREDIT_CARD_REQUEST_STATUS";
function setCheckInfoRequestStatus(checkInfo) {
    return {
        type: SET_CHECK_INFO,
        checkInfo: checkInfo,
    };
}
function setMerchantInfoRequestStatus(merchantInfo) {
    return {
        type: SET_MERCHANT_INFO,
        merchantInfo: merchantInfo,
    };
}
function setProcessedPaymentRequestStatus(processedPaymentInfo) {
    return {
        type: SET_PROCESSED_PAYMENT_INFO,
        processedPaymentInfo: processedPaymentInfo,
    };
}
export function setCreditCardRequestStatus(status) {
    return {
        type: SET_CREDIT_CARD_REQUEST_STATUS,
        status: status,
    };
}
export function getAndUpdateCheckInfo() {
    return function (dispatch) {
        dispatch(setCheckInfoRequestStatus({
            type: RequestStatus.REQUESTING,
        }));
        getCheckInfo()
            .then(function (checkInfo) {
            dispatch(setCheckInfoRequestStatus({
                type: RequestStatus.SUCCESS,
                result: checkInfo,
            }));
        })
            .catch(function (error) {
            dispatch(setCheckInfoRequestStatus({
                type: RequestStatus.FAILURE,
                reason: "error fetching info from the OLO backend",
            }));
            // if we aren't getting a check back it either
            // doesn't exist or the olo backend is down
            TrackJS.track("error fetching check info from OLO backend: " + error);
        });
    };
}
export function getAndUpdateMerchantInfo() {
    return function (dispatch) {
        dispatch(setMerchantInfoRequestStatus({
            type: RequestStatus.REQUESTING,
        }));
        getMerchantInfo()
            .then(function (merchantInfo) {
            if ("redirectPrettyUrl" in merchantInfo) {
                window.location.replace(BASE_URL + "/s/" + merchantInfo.redirectPrettyUrl + "/pay" + window.location.search);
            }
            else {
                dispatch(setMerchantInfoRequestStatus({
                    type: RequestStatus.SUCCESS,
                    result: merchantInfo,
                }));
            }
        })
            .catch(function (error) {
            dispatch(setMerchantInfoRequestStatus({
                type: RequestStatus.FAILURE,
                reason: "error fetching merchant info from S3",
            }));
            // if we aren't getting a merchant back it either
            // doesn't exist or AWS is down
            TrackJS.track("error fetching merchant info from S3: " + error);
        });
    };
}
function catchCardRegistrationError(error) {
    return function (dispatch) {
        dispatch(setCreditCardRequestStatus(RequestStatus.FAILURE));
        TrackJS.track("error registering credit card: " + error);
    };
}
function catchPaymentError(error, submissionId) {
    return function (dispatch) {
        batch(function () {
            // Attempt to get a more specific error message from the repsonse body
            error.response
                .json()
                .then(function (resp) {
                var _a;
                dispatch(setProcessedPaymentRequestStatus({
                    type: RequestStatus.FAILURE,
                    reason: (_a = resp.message) !== null && _a !== void 0 ? _a : error.message,
                }));
            })
                .catch(function () {
                dispatch(setProcessedPaymentRequestStatus({
                    type: RequestStatus.FAILURE,
                    reason: "There was an error processing your request. Please check the form and try again.",
                }));
            })
                .finally(function () {
                return dispatch(setCreditCardRequestStatus(RequestStatus.FAILURE));
            });
        });
        TrackJS.track("error submitting order for submission id " + submissionId + ": " + error);
    };
}
export function submitCreditCardPayment(_a) {
    var checkInfo = _a.checkInfo, total = _a.total, balanceDue = _a.balanceDue, tip = _a.tip, paymentMethodToken = _a.paymentMethodToken, cardInfo = _a.cardInfo;
    var submissionId = uuid();
    var cardForRegistry = transformCardForRegistry(cardInfo, paymentMethodToken);
    return function (dispatch) {
        registerCard(cardForRegistry)
            .then(function (_a) {
            var consumerId = _a.consumerId, cardId = _a.cardId;
            var paymentRequestInfo = transformCardForProcessing(checkInfo, total, balanceDue, cardId, cardInfo, consumerId, tip, submissionId);
            dispatch(setProcessedPaymentRequestStatus({
                type: RequestStatus.REQUESTING,
            }));
            postCreditCardPayment(paymentRequestInfo)
                .then(function (processedPaymentInfo) {
                batch(function () {
                    dispatch(setProcessedPaymentRequestStatus({
                        type: RequestStatus.SUCCESS,
                        result: processedPaymentInfo,
                    }));
                    dispatch(setCreditCardRequestStatus(RequestStatus.SUCCESS));
                });
            })
                .catch(function (error) {
                dispatch(catchPaymentError(error, submissionId));
            });
        })
            .catch(function (error) {
            dispatch(catchCardRegistrationError(error));
        });
    };
}
